module.exports = __webpack_public_path__ + "static/media/KG.70103cb0.png";